import { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import RevokeRequestForm from './revokeRequestForm';

class RevokeRequest extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get Request Info',
                content: <GetInfo apiLink='requests/getRequest' param request />,
                id: 0,
            }, {
                title: 'Revoke Request',
                content: <RevokeRequestForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default RevokeRequest
